import {useCallback, useEffect, useRef} from 'react'

// https://github.com/react-restart/hooks/blob/master/src/useEventCallback.ts
// https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback

const useEventCallback = (fn) => {
  const ref = useRef(fn)

  useEffect(() => {
    ref.current = fn
  }, [fn])

  return useCallback((...args) => {
    return ref.current(...args)
  }, []) 
}

export default useEventCallback
